import LightboxButton from "./LightboxButton";
import { useState } from "react";
import { TYPE_STUDIES, TYPE_STUDIES_ROUND_2, TYPE_STUDIES_ROUND_3 } from "./typefaces";
import type { Typeface } from "./typefaces";
import styles from "./TypeReview.module.scss";

type Props = { value: Typeface; onChange: (value: Typeface) => void };
/* UI-DESIGN: visible only with ?type=…; switching in place keeps the
   exact scroll position and selected slide available for comparison. */
const TypeReview = ({ value, onChange }: Props) => {
  /* UI-DESIGN: LB-57 round 3 (the chosen Clue Typed vs before) opens first */
  const asked = Number(new URLSearchParams(window.location.search).get("round"));
  const [round, setRound] = useState([1, 2, 3].includes(asked) ? asked : ["courier-regular", "cutive", "plex"].includes(value) ? 2 : 3);
  const studies = round === 3 ? TYPE_STUDIES_ROUND_3 : round === 2 ? TYPE_STUDIES_ROUND_2 : TYPE_STUDIES;
  const selected = [...TYPE_STUDIES_ROUND_3, ...TYPE_STUDIES, ...TYPE_STUDIES_ROUND_2].find((face) => face.id === value);
  const query = new URLSearchParams(window.location.search);
  query.set("type", value);
  query.set("round", String(round));
  return (
  <aside className={styles.review} aria-label="Typography review">
    <div className={styles.meta}>
      <button className={styles.round} onClick={() => setRound(round === 3 ? 1 : round + 1)}>Round {round} · switch</button>
      <nav className={styles.pages} aria-label="Review pages">
        <a href={`/?${query}`} aria-current={window.location.pathname === "/" ? "page" : undefined}>Home</a>
        <a href={`/games?${query}`} aria-current={window.location.pathname === "/games" ? "page" : undefined}>Cases</a>
      </nav>
    </div>
    <div className={styles.choices} role="group" aria-label="Type direction">
      {studies.map((face) => (
        <LightboxButton
          key={face.id}
          tone="secondary"
          className={styles.choice}
          aria-pressed={value === face.id}
          aria-description={face.detail}
          onPress={() => onChange(face.id)}
        >
          {face.label}
        </LightboxButton>
      ))}
    </div>
    <p className={styles.detail} aria-live="polite"><strong>{selected?.detail ?? value}</strong><span>{selected?.note}</span></p>
  </aside>
  );
};
export default TypeReview;
